export enum ItemAdminOrderType {
  ALL = "ALL",
  CATEGORY = "CATEGORY",
  IS_FOR_SALE = "IS_FOR_SALE",
  IS_DISPLAYED = "IS_DISPLAYED",
}

export enum ItemAdminOrderTypeExpanded {
  ALL = "ALL",
  CATEGORY = "CATEGORY",
  CATEGORY_ASC = "CATEGORY_ASC",
  CATEGORY_DESC = "CATEGORY_DESC",
  IS_FOR_SALE = "IS_FOR_SALE",
  IS_FOR_SALE_ASC = "IS_FOR_SALE_ASC",
  IS_FOR_SALE_DESC = "IS_FOR_SALE_DESC",
  IS_DISPLAYED = "IS_DISPLAYED",
  IS_DISPLAYED_ASC = "IS_DISPLAYED_ASC",
  IS_DISPLAYED_DESC = "IS_DISPLAYED_DESC",
  IS_CATALOGED = "IS_CATALOGED",
  IS_CATALOGED_ASC = "IS_CATALOGED_ASC",
  IS_CATALOGED_DESC = "IS_CATALOGED_DESC",
  NAME = "NAME",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
}
